var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTexas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 168.004,
    height: 161.226,
    viewBox: "0 0 168.004 161.226",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "u6xg6veoza",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2362cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d4fa3"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u6xg6veoza)",
    fillRule: "evenodd",
    d: "M555.653 500.924l3.695 2.945 4.988-1.472 2.3 3.974 6.977 1.722H580l2.28 4.163 3.621-2.294 5.653 2.294 3.765-2.294 7.221 4.095 8.786-3.528 2.7 1.727 3.133-1.727 10.178 5.544h4.1v23.174l3.142 4.636 3.725 9.839v3.732l-2.1 6.241v6.374l-3.327 4.606-7.1 3.185-3.062-3.752-4 .567 1.894 7.488-12.479 8.93-8.973-1.074 1.679 5.147-3.863-1.577-1.094 2.708-4.331 1.134 1.833 5.113H587.9l3.655 2.267v2.5H585.9v3.9l2.563.567 1.132 7.454 1.959 9.29-1.959 2.721-3.695-2.721H580l-6.392-3.223-6.977-1.964-.567-5.239-3.264-3.015-1.132-8.333-2.321-1.932-6.562-7.38-8.385-17.485-6.582-5.275-11.957-1.7-4.292 1.132-6.03 11.418-17.639-7.665-2.4-6.415-2.4-7.75-4.821-4.529-12.834-10.767-5.142-4.518v-3.139h46.171v-70.73h39.18z",
    transform: "translate(-470.303 -470.013)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTexas);
export default __webpack_public_path__ + "static/media/icon-texas.f918cc3507b828f713b8d3a4bd49fc76.svg";
export { ForwardRef as ReactComponent };